import { Component, OnInit} from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-seller-sidebar',
  templateUrl: './sidbar.component.html',
  styleUrls: ['./sidbar.component.scss'],
})
export class SellerSidebarComponent implements OnInit {
  
  constructor() {}

  ngOnInit(): void {}


}
